const LnoUrl = [
	'api/test/newTestTask',
	'api/msg/userStatic',
	'api/test/statics',
	'api/index/userInfo',
	'api/msg/dept',
	'api/system/QR/getQRType',
	'api/system/QR/getLoginQR',
	'api/system/QR/getLoginQR',
	'api/test/tableCat',
	'api/test/subTableById',
	'api/test/getSurvey',
	'api/test/getSurveyById',
	'api/test/getPublishers',
	'api/test/getSurveyByIdTable',
	'api/test/getSurveyByIdTable',
	'api/expert/ordersList',
	'api/expert/workDate',
	'api/expert/workDateTime',
	'api/expert/workDateTime',
	'api/expert/consultedList',
	'api/test/getTableResultList',
	'api/test/getTableResultById',
	'api/test/getPublishInfoList',
	'api/test/getTableResultList',
	'api/test/getTeamResultByInfoId',
	'api/test/getSurveyResultList',
	'api/comment/getAllTemplate',
	'api/test/warningList',
	'api/test/getTableResultById',
	'api/msg/manageDept',
	'api/msg/getStudentIdBySomeDept',
	'api/msg/getUserInfoBySID',
	'api/admin/QuestionTest/getQuestionnaireList',
	'api/admin/QuestionTest/getQuestionPublishers',
	'api/admin/Questionnaire/startSubtest',
	'api/admin/Testresult/searchQuestionResult',
	'api/admin/AdminTestresult/searchAdminQuestionResult',
	'api/admin/QuestionTest/getQuestionBankList',
	'api/admin/question/getQuestionnaireInfo',
	'api/admin/question/getSubTest',
	'api/admin/questionTest/getQuestionnaireCategory',
	'api/admin/publish/QuestionInfo',
	'api/admin/publish/searchPublishInfo',
	'api/test/getPubAllTable',
	'api/admin/Interact/getUserinfo',
	'api/test/reportStatic',
	'api/system/config/info',
	'api/test/statistics',
	'api/test/subTable',
	'api/admin/questionTest/getQuestionnaireCategory',
	'api/msg/user',
	'api/msg/someDept',
	'api/expert/expertsList',
	'api/system/Location/getProvince',
	'api/system/Location/getCity',
	'api/system/Location/getArea',
	'api/system/company/info',
	'api/msg/allUser',
	'api/admin/publish/questionInfoAll',
	'api/system/recycle/getReportType',
	'api/system/recycle/delUserList',
	'api/system/recycle/getAllEditor',
	'api/system/recycle/getAllCategory',
	'api/system/Backup/getBackList',
	'api/msg/adminUser',
	'api/msg/usersTemplate',
	'api/test/getAllTable',
	'api/msg/record',
	'api/msg/clicks',
	'api/test/tableResultOperate',
	'api/admin/AdminTestresult/checkAdminQuestionResult',
	'api/msg/macHost',
	'api/test/pubUserList',
	'api/msg/AllDept',
	'api/expert/readOrder',
	'api/system/recycle/delQBList',
	'api/system/recycle/delReportList',
	'api/test/getReadTable',
	'api/admin/question/addQuestionnaire',
	'api/admin/Questionnaire/startQuestionnaire',
	'api/test/getTMinShoolInfoId',
	'api/test/statistics',
	'api/test/addManSubTable',
	'api/test/getSomeCatGauge',
	'api/test/getSomeTestQuestions',
	'api/test/commitTeam',
	'api/test/getResultScale',
	'api/test/getRecordImage',
	'api/user/detail',
	'api/export/filterGaugeRecord',
	'api/export/gaugeWordExport',
	'api/expert/expertInfo',
	'api/export/taskList',
	'api/export/filterQuestionRecord',
	'api/export/filterSurveyRecord',
	'api/export/filterWaringRecord',
	'api/admin/Testresult/checkSubtest',
	'api/admin/AdminTestresult/getAdminSubtest',
	'api/expert/noReadStatic',
	'api/test/getMHRSPInfoId',
	'api/admin/Testresult/checkQuestionResult',
	'api/test/getSCL90InfoId',
	'api/msg/analysisImportUsers',
];

export { LnoUrl };
